import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import { constVoid } from 'fp-ts/function';
import { Translation } from 'react-i18next';
import { Avatar } from '../avatar';
import { Link } from '../link';
import { UnavailableInLens } from '../unavailable-in-lens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PopoverAction = function PopoverAction(_ref) {
  var to = _ref.to,
      children = _ref.children;
  return /*#__PURE__*/_jsx(Button, {
    variant: "contained",
    to: to,
    component: Link,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    "data-element": "Button",
    "data-component": "PopoverAction",
    "data-source-file": "popover-content.tsx",
    children: children
  });
};

var MemberTitleAndCompany = function MemberTitleAndCompany(_ref2) {
  var member = _ref2.member;
  return member.title && member.company ? /*#__PURE__*/_jsx(Translation, {
    children: function children(t) {
      return /*#__PURE__*/_jsx(Typography, {
        variant: "body2",
        children: t("{{- title}} at {{- company}}", {
          title: member.title,
          company: member.company
        })
      });
    }
  }) : /*#__PURE__*/_jsx(Typography, {
    variant: "body2",
    children: member.title
  });
};

var PopoverContent = function PopoverContent(_ref3) {
  var member = _ref3.member,
      canViewProfile = _ref3.canViewProfile,
      allowMessaging = _ref3.allowMessaging,
      _ref3$onViewProfile = _ref3.onViewProfile,
      onViewProfile = _ref3$onViewProfile === void 0 ? constVoid : _ref3$onViewProfile;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "PopoverContent",
    "data-source-file": "popover-content.tsx",
    children: function children(t) {
      var _member$level;

      return /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'row'
        },
        children: [/*#__PURE__*/_jsx(Avatar, {
          sx: {
            mt: 1
          },
          size: "medium",
          member: member,
          disabledPopover: true
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            ml: 3,
            display: 'flex',
            flexDirection: 'column'
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            children: member.name
          }), (member.title || member.company) && /*#__PURE__*/_jsx(MemberTitleAndCompany, {
            member: member
          }), ((_member$level = member.level) === null || _member$level === void 0 ? void 0 : _member$level.name) && /*#__PURE__*/_jsx(Typography, {
            variant: "body2",
            children: t("Level: {{memberLevel}}", {
              memberLevel: member.level.name
            })
          }), member.tags.length > 0 && /*#__PURE__*/_jsx(Stack, {
            direction: "row",
            flexWrap: "wrap",
            sx: {
              mt: 1,
              maxWidth: 280,
              gap: 0.5
            },
            children: member.tags.flatMap(function (tag) {
              return tag.terms.map(function (term) {
                return /*#__PURE__*/_jsx(Chip, {
                  label: term.displayName,
                  size: "small"
                }, "".concat(tag.taxonomy.slug, ":").concat(term.slug));
              });
            })
          }), /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              gap: 1,
              pt: canViewProfile || allowMessaging ? 1 : 0
            },
            children: [canViewProfile && /*#__PURE__*/_jsx("div", {
              onClick: onViewProfile,
              children: /*#__PURE__*/_jsx(PopoverAction, {
                to: "/profiles/".concat(member.id),
                children: t('View Profile')
              })
            }), allowMessaging ? /*#__PURE__*/_jsx(UnavailableInLens, {
              tooltip: true,
              children: /*#__PURE__*/_jsx(PopoverAction, {
                to: "/chat?p=".concat(member.id),
                children: t('Message')
              })
            }) : null]
          })]
        })]
      });
    }
  });
};

export default PopoverContent;